export default "__VITE_ASSET__Bqo$tVAr__"